import JDList from "./JDList";
export default JDList;
